import React, { FC } from 'react';
import { Field, ErrorMessage } from 'formik';
import { IFormControl } from '../formInterface';
import { TextField, Typography } from '@getgo/chameleon-web/react';
import FormErrorMessageBox from './formErrorMessageBox';

const FormInput: FC<IFormControl> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { title, name, size, required, children, ...rest } = props;

  return (
    <Field name={name}>
      {({ form, field, meta: { touched, error } }: any) => {
        return (
          <>
            <TextField
              id={name}
              {...field}
              name={name}
              className="full-width"
              error={touched && error}
              onChange={(e) => form.handleChange(e)}
              {...rest}
            >
              <Typography variant="caption-default-02" color="text-01">
                {title}
                {required && '*'}
              </Typography>
              {props.children}
            </TextField>
            <ErrorMessage
              name={name}
              render={() => <FormErrorMessageBox errorMessage={form.errors[name]} />}
            />
          </>
        );
      }}
    </Field>
  );
};

export default FormInput;
